import AddPeopleForm from "../../components/Form/AddPeopleForm";
import React, { useState } from 'react';
import ListSwitch from "../../components/List/ListSwitch";
import GridTabFolding from "../../components/Grid/GridTabFolding";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faFemale, faXmark} from "@fortawesome/free-solid-svg-icons";
import styles from "../../components/Grid/GridTabFolding.module.css";
import Filter from "../../components/Filter/Filter";
import {fetchWithFiltersLocal} from "../../services/FilterService";
import Search from "../../components/Search/SearchReferent";
import {searchReferents, searchUsers} from "../../services/SearchService";

const SearchTestPage = props => {
    const getSeanceData = async (datum) => {
    };

    return (
        <div className="content">
            <AddPeopleForm id={23} onSubmit={getSeanceData} />
            <Search id={23} onSubmit={getSeanceData} entrepriseId={6}/>
        </div>
    );
};

export default SearchTestPage;
